import FoodItemCard, { FoodItemCardProps } from './FoodItemCard';

export type { FoodItemCardProps };
export default FoodItemCard;
